module.exports = __webpack_public_path__ + "img/Body Shaping Treatments 3.a6fa729f.jpg";